import { ShowNumber as AntdShowNumber } from "@empglabs/backoffice-ui-kit"

const ShowNumber = props => {
  return <AntdShowNumber {...props} />
}

export default ShowNumber
